import { RequestMethod } from '@videoblocks/events-ts/lib/storyblocks/content/ai/RequestMethodEnum';

import KafkaRestClient from '../kafka/KafkaRestClient';
import { AiContentGenerateEventFactory } from './AiContentGenerateEventFactory';
import { AiContentServiceCommonOptions } from './AiContentServiceTypes';

export interface AiContentGenerateServiceOptions extends AiContentServiceCommonOptions {
    requestUrl: string;
    requestMethod: keyof typeof RequestMethod;
    requestHeaders?: Record<string, string>;
    requestQueryParams?: Record<string, string>;
    requestBody?: string | null;
    responseStatusCode: number;
    responseHeaders?: Record<string, string>;
    responseBody?: string | null;
}

async function publishEvent(args: AiContentGenerateServiceOptions): Promise<void> {
    const {
        aiContentId,
        lastAiContentId,
        voiceId,
        aiContentVoiceoverType,
        requestUrl,
        requestMethod,
        requestHeaders,
        requestQueryParams,
        requestBody,
        responseStatusCode,
        responseHeaders,
        responseBody,
        cookies,
        currentUrl,
        referrer,
        headers,
        geo,
    } = args;

    const visitorIdCookie = cookies.get('VID')?.value ?? null;
    const loginSessionToken = cookies.get('login_session')?.value;
    const ipAddress = headers.get('X-Forwarded-For') ?? null;

    const event = await AiContentGenerateEventFactory.create({
        aiContentId,
        lastAiContentId,
        voiceId,
        aiContentVoiceoverType,
        requestUrl,
        requestMethod,
        requestHeaders,
        requestQueryParams,
        requestBody,
        responseStatusCode,
        responseHeaders,
        responseBody,
        visitorCookieId: visitorIdCookie,
        sessionToken: loginSessionToken,
        currentUrl,
        referrer,
        headers,
        geo,
        ipAddress,
    });

    await KafkaRestClient.produce(event);
}

export const AiContentGenerateService = { publishEvent };
